var env = {
	origin: window.location.origin
};

module.exports = env;


/** WEBPACK FOOTER **
 ** ./_services/env.js
 **/